var render, staticRenderFns
import script from "./EntryMenusItem.vue?vue&type=script&lang=js&"
export * from "./EntryMenusItem.vue?vue&type=script&lang=js&"
import style0 from "./EntryMenusItem.vue?vue&type=style&index=0&id=20456ea4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20456ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20456ea4')) {
      api.createRecord('20456ea4', component.options)
    } else {
      api.reload('20456ea4', component.options)
    }
    
  }
}
component.options.__file = "src/components/EntryLayout2/EntryMenusItem.vue"
export default component.exports